import React from 'react';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

export const LoggedOutLinks: React.ComponentType = () => (
	<Button variant="text" to="/login" component={Link} color="inherit">
		{'Log'}&nbsp;{'in'}
	</Button>
);
